export default __webpack_public_path__ + "static/media/Cubicus.3121f521.jpg";